/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { combineReducers } from 'redux';
import { sarsaparillaReducers } from 'sarsaparilla';
import { authReducers } from 'shared-ui/auth/redux';

import lotteryReducers from '../src/reducers/lottery';

const createRootReducer = combineReducers({
    lottery: lotteryReducers,
    ...sarsaparillaReducers,

    // Auth - MUST COME AFTER SARSA REDUCERS DURING AUTH MIGRATION
    ...authReducers,
});

export default createRootReducer;
